import { render, staticRenderFns } from "./OfferListItem.vue?vue&type=template&id=705c2936&"
import script from "./OfferListItem.vue?vue&type=script&lang=js&"
export * from "./OfferListItem.vue?vue&type=script&lang=js&"
import style0 from "./OfferListItem.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VImg,VListItemAvatar,VListItemContent})
